import { render } from "./BorangPMKKNP-form-pegawai-psm.vue?vue&type=template&id=34bff46e&ts=true"
import script from "./BorangPMKKNP-form-pegawai-psm.vue?vue&type=script&lang=ts"
export * from "./BorangPMKKNP-form-pegawai-psm.vue?vue&type=script&lang=ts"

import "./BorangPMKKNP-form-pegawai-psm.vue?vue&type=style&index=0&id=34bff46e&lang=css"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__